import React from 'react'
import "./Services.scss"
import automation from "../../assets/images/services/automation.svg"
import sales from "../../assets/images/services/sales.svg"
import tasks from "../../assets/images/services/tasks.svg"
import { useLanguage } from "../../LanguageContext";

const Services = () => {
    const { t } = useLanguage();
    
  return (
    <div className="servicesSection">

        <div className="servicesHeading">
            <h2>{t("services_hero_title")}</h2>
            <p className="primary">{t("services_hero_description")}</p>
        </div>

        <div className="servicesCards">

            <div className="serviceCard">
               <div className="serviceCardImg">
                  <img src={automation} alt="" />
               </div>
               <div className="serviceCardContent">
                  <p className="tertiary">{t("services_card_title_1")}</p>
                  <h3>{t("services_card_title_1_1")}</h3>
                  <p className="primary">{t("services_card_title_1_1_description")}</p>
               </div>
            </div>

            <div className="serviceCard">
               <div className="serviceCardImg">
                  <img src={tasks} alt="" />
               </div>
               <div className="serviceCardContent">
                  <p className="tertiary">{t("services_card_title_2")}</p>
                  <h3>{t("services_card_title_2_1")}</h3>
                  <p className="primary">{t("services_card_title_2_1_description")}</p>
               </div>
            </div>

            <div className="serviceCard">
               <div className="serviceCardImg">
                  <img src={sales} alt="" />
               </div>
               <div className="serviceCardContent">
                  <p className="tertiary">{t("services_card_title_3")}</p>
                  <h3>{t("services_card_title_3_1")}</h3>
                  <p className="primary">{t("services_card_title_3_1_description")}</p>
               </div>
            </div>

            <div className="serviceCard">
               <div className="serviceCardImg">
                  <img src={automation} alt="" />
               </div>
               <div className="serviceCardContent">
                  <p className="tertiary">{t("services_card_title_4")}</p>
                  <h3>{t("services_card_title_4_1")}</h3>
                  <p className="primary">{t("services_card_title_4_1_description")}</p>
               </div>
            </div>

             <div className="serviceCard">
               <div className="serviceCardImg">
                  <img src={automation} alt="" />
               </div>
               <div className="serviceCardContent">
                  <p className="tertiary">{t("services_card_title_5")}</p>
                  <h3>{t("services_card_title_5_1")}</h3>
                  <p className="primary">{t("services_card_title_5_1_description")}</p>
               </div>
            </div>
        </div>

    </div>
  )
}

export default Services